import type { PropsWithChildren } from 'react';
import React from 'react';
import { GovFlex } from '@gov-design-system-ce/react';
import type { GovFlexProps } from '@gov-design-system-ce/react/lib/gov-flex/GovFlex';

export type DSGovFlexProps = PropsWithChildren<
	Omit<GovFlexProps, 'classNames' | 'children'> & {
		className?: string;
	}
>;

export const DSGovFlex = (props: DSGovFlexProps) => (
	<GovFlex {...props}>{props.children}</GovFlex>
);
